export default __webpack_public_path__ + "80e2849.png";